<template>
<div class="ticket-manage">
    <div class="page-title">电子券使用展示</div>
    <div class="page-title-bottom-line"></div>
    <div class="main-content-90">
        <div class="controller-container">
            <div class="controller-content">
                <el-select class="action-select-first" @change="selectPeopleClass" v-model="currentPeopleClassIndex" placeholder="选择人群">
                    <el-option v-for="(item, index) in peopleClassArr" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="table-container">
            <el-table key="1" v-if="currentPeopleClassIndex == 0" :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="number" label="电子券码" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="user_wc_name" label="扫码者微信名" min-width="25%">
                    <template slot-scope="scope">
                        <div class="wechat-column"><i class="icon iconfont icon-yonghu2"></i>&nbsp;&nbsp;{{scope.row.user_wc_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="store_name" label="门店名称" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="time" label="扫码时间" min-width="25%">
                </el-table-column>
            </el-table>
            <el-table key="2" v-else-if="currentPeopleClassIndex == 1" :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="customer_phone" label="评价内容" min-width="20%">
                    <template slot-scope="scope">
                        <el-popover
                            placement="top-bottom"
                            title="评价内容"
                            width="200"
                            trigger="hover"
                            :content="scope.row.evaluate_content">
                            <span slot="reference">{{scope.row.shortComment}}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="评价星级" min-width="12%">
                    <template slot-scope="scope">
                        <span>{{scope.row.evaluate_grade}}星</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="store_name" label="门店名称" min-width="20%">
                </el-table-column>
                <el-table-column align="center" prop="time" label="扫码时间" min-width="12%">
                </el-table-column>
                <el-table-column align="center" prop="number" label="电子券码" min-width="12%">
                </el-table-column>
                <el-table-column align="center" prop="customer_name" label="消费者姓名" min-width="12%">
                </el-table-column>
                <el-table-column align="center" prop="em_coupon_code" label="优惠券码" min-width="12%">
                </el-table-column>
                <el-table-column align="center" prop="customer_phone" label="消费者电话" min-width="12%">
                </el-table-column>
            </el-table>
            <el-table key="3" v-else-if="currentPeopleClassIndex == 2" :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="customer_name" label="消费者姓名" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="time" label="扫码时间" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="number" label="电子券码" min-width="25%">
                </el-table-column>
                <el-table-column align="center" prop="customer_phone" label="消费者电话" min-width="25%">
                </el-table-column>
            </el-table>
            
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import Tool from '../../assets/js/Tool.js'
export default {
    data() {
        return {
            peopleClassArr: [
                // {
                //     'name': '门店扫码',
                //     'id': 0
                // },
                {
                    'name': '门店评价',
                    'id': 1
                },
                {
                    'name': '营销发放',
                    'id': 2
                }
            ],
            currentPeopleClassIndex: 1,
            tableData: [],
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created () {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 0) {
                return 'color: #29bd7f;';
            }
            return 'color: #000;'
        },
        init() {
            this.selectPeopleClassByClassId(this.currentPeopleClassIndex);
        },
        selectPeopleClassByClassId (classId) {
            this.axios.get('/card_list', {
                params: {
                    style: classId
                }
            })
            .then(res => {
                res.data.data.forEach(item => {
                    if(classId == 1) {
                        item.shortComment = Tool.getShortText(item.evaluate_content, 8) + '...';
                    }
                });
                this.$set(this, 'tableData', {});
                this.$set(this, 'tableData', res.data.data);
            })
        },
        selectPeopleClass () {
            this.selectPeopleClassByClassId(this.currentPeopleClassIndex);
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);
@import url(https://at.alicdn.com/t/font_976438_kvydgtappuo.css);
.ticket-manage {
    background-color: #F9F9F9;
}
.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}
.action-select-first {
    margin-left: 0px;
}
.wechat-column {
    padding-left: 25px;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/ticketManage/TicketManage.vue